import React from 'react';
import MealBrandDetails from 'components/meal-content/meal-brand-details';

const NewMealBrandDetails = () => {
  return <MealBrandDetails />;
};

export default NewMealBrandDetails;
